import React from 'react'

export default function InternalBanner(props) {
  return (
    <section className="single-banner internal-banner">
            <div className="container">
                <h2>{props.title}</h2>
                <h4>{props.venue}</h4>
            </div>
        </section>
  )
}
